import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './Gauge.css'
import { useTranslation } from 'react-i18next'
import { SUPERVISION_PERF_SCORE } from '../../constants/supervision'

function Gauge({ perf }) {
	const { t } = useTranslation(['gauge'])
	const [performance, setPerformance] = useState(null)
	const [needleAngle, setNeedleAngle] = useState(0)

	const getPerfString = (code) =>
		Object.keys(SUPERVISION_PERF_SCORE).find((key) => SUPERVISION_PERF_SCORE[key].code === code)

	useEffect(() => {
		const normalizedPerf = 100 - perf
		const targetAngle = (normalizedPerf * 180) / 100
		let secondFrame
		const firstFrame = requestAnimationFrame(() => {
			secondFrame = requestAnimationFrame(() => setNeedleAngle(targetAngle))
		})
		if (
			normalizedPerf >= SUPERVISION_PERF_SCORE.FAST.min &&
			normalizedPerf < SUPERVISION_PERF_SCORE.FAST.max
		) {
			setPerformance(getPerfString(SUPERVISION_PERF_SCORE.FAST.code))
		} else if (
			normalizedPerf >= SUPERVISION_PERF_SCORE.MEDIUM.min &&
			normalizedPerf < SUPERVISION_PERF_SCORE.MEDIUM.max
		) {
			setPerformance(getPerfString(SUPERVISION_PERF_SCORE.MEDIUM.code))
		} else if (
			normalizedPerf >= SUPERVISION_PERF_SCORE.LOW.min &&
			normalizedPerf <= SUPERVISION_PERF_SCORE.LOW.max
		) {
			setPerformance(getPerfString(SUPERVISION_PERF_SCORE.LOW.code))
		}
		return () => {
			cancelAnimationFrame(firstFrame)
			cancelAnimationFrame(secondFrame)
		}
	}, [perf])

	return (
		<div className="gauge-wrapper">
			<div className={`gauge three risk`}>
				<div className="slice-colors">
					<div className="st slice-item"></div>
					<div className="st slice-item"></div>
					<div className="st slice-item"></div>
				</div>
				<div
					className="needle"
					style={{ transform: `rotate(${needleAngle}deg)` }}
				></div>
				<div className="gauge-center">
					<div className="label">{t('gauge:title')}</div>
					<div className="number">{performance ? t(`gauge:${performance}`) : ''}</div>
				</div>
			</div>
		</div>
	)
}
Gauge.propTypes = {
	perf: PropTypes.number,
}

export default Gauge
